export function getApplicationKey(modelId: string) {
	const applicationId = getApplicationId(modelId);
	return applicationId !== null ? convertAppIdToKey(applicationId) : null;
}

export function getApplicationId(modelId: string) {
	return isApplicationDocument(modelId) ? modelId.split("_")[0] : null;
}

export function isApplicationDocument(modelId: string) {
	return modelId.match(/[A-Z]{2,7}\d*_.*/);
}

export function convertAppIdToKey(fvId: string) {
	return fvId.replace(/\d+/, "");
}

export function cleanAppIdPrefix(taskKey: string) {
	return taskKey.replace(/[A-Z]{2,8}\d+_/, "");
}
